import { render } from "./DijiaNumberPoolNumber.vue?vue&type=template&id=50b59c3a&scoped=true"
import script from "./DijiaNumberPoolNumber.vue?vue&type=script&lang=js"
export * from "./DijiaNumberPoolNumber.vue?vue&type=script&lang=js"

import "./DijiaNumberPoolNumber.vue?vue&type=style&index=0&id=50b59c3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50b59c3a"

export default script